module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/a2f2f3a8d547ed146674af72dde149a4.png";